const emoji = [
  {'{emoji:2}': '2.png'},
  {'{emoji:3}': '3.png'},
  {'{emoji:4}': '4.png'},
  {'{emoji:5}': '5.png'},
  {'{emoji:6}': '6.png'},
  {'{emoji:7}': '7.png'},
  {'{emoji:8}': '8.png'},
  {'{emoji:9}': '9.png'},
  {'{emoji:10}': '10.png'},
  {'{emoji:11}': '11.png'},
  {'{emoji:12}': '12.png'},
  {'{emoji:13}': '13.png'},
  {'{emoji:14}': '14.png'},
  {'{emoji:15}': '15.png'},
  {'{emoji:16}': '16.png'},
  {'{emoji:17}': '17.png'},
  {'{emoji:18}': '18.png'},
  {'{emoji:19}': '19.png'},
  {'{emoji:20}': '20.png'},
  {'{emoji:21}': '21.png'},
  {'{emoji:22}': '22.png'},
  {'{emoji:23}': '23.png'},
  {'{emoji:24}': '24.png'},
  {'{emoji:25}': '25.png'},
  {'{emoji:26}': '26.png'},
  {'{emoji:27}': '27.png'},
  {'{emoji:28}': '28.png'},
  {'{emoji:29}': '29.png'},
  {'{emoji:30}': '30.png'},
  {'{emoji:31}': '31.png'},
  {'{emoji:32}': '32.png'},
  {'{emoji:33}': '33.png'},
  {'{emoji:34}': '34.png'},
  {'{emoji:35}': '35.png'},
  {'{emoji:36}': '36.png'},
  {'{emoji:37}': '37.png'},
  {'{emoji:38}': '38.png'},
  {'{emoji:39}': '39.png'},
  {'{emoji:40}': '40.png'},
  {'{emoji:41}': '41.png'},
  {'{emoji:42}': '42.png'},
  {'{emoji:43}': '43.png'},
  {'{emoji:44}': '44.png'},
  {'{emoji:45}': '45.png'},
  {'{emoji:46}': '46.png'},
  {'{emoji:47}': '47.png'},
  {'{emoji:48}': '48.png'},
  {'{emoji:49}': '49.png'},
  {'{emoji:50}': '50.png'},
  {'{emoji:51}': '51.png'},
  {'{emoji:52}': '52.png'},
  {'{emoji:53}': '53.png'},
  {'{emoji:54}': '54.png'},
  {'{emoji:55}': '55.png'},
  {'{emoji:56}': '56.png'},
  {'{emoji:57}': '57.png'},
  {'{emoji:58}': '58.png'},
  {'{emoji:59}': '59.png'},
  {'{emoji:60}': '60.png'}
]

export default emoji
